import apiClient from './apiClient';
import { BillReportSummary } from '../types/Report';

export const reportService = {
  getBillingReport: async (
    startDate: string,
    endDate: string,
    status?: string,
    paymentMethod?: string,
    createdByUserId?: number
  ): Promise<BillReportSummary> => {
    const params: string[] = [
      `startDate=${startDate}`,
      `endDate=${endDate}`,
    ];
    if (status) params.push(`status=${encodeURIComponent(status)}`);
    if (paymentMethod) params.push(`paymentMethod=${encodeURIComponent(paymentMethod)}`);
    if (createdByUserId) params.push(`createdByUserId=${createdByUserId}`);
    const response = await apiClient.get(`/reports/billing?${params.join('&')}`);
    return response.data;
  },
};
